<template>
  <div>
    <v-autocomplete
      v-model="searchType"
      clearable
      label="Search type"
      :items="searchTypes"
      item-text="label"
      item-value="key"
      color="blue"
      item-color="info"
      menu-props="light"
      @change="editableFacet = null"
    />

    <v-autocomplete
      v-if="searchType"
      v-model="editableFacet"
      clearable
      :label="label"
      :items="facetsList"
      item-text="label"
      item-value="value"
      color="blue"
      item-color="info"
      menu-props="light"
      @change="updateSelectedFacet()"
    />

    <div v-if="editableFacet">
      <v-card-title class="pa-1">
        <h3 class="white--text"> PIN ITEMS</h3>
      </v-card-title>
      <draggable
        v-model="draggableItems"
        class="d-flex flex-wrap"
        style="width: 100%"

        @change="updateContent('pinItem')"
      >
        <div v-for="(item, index) in draggableItems" :key="index" class="pa-1 mt-1" style="width: 100%">
          <v-chip class="mr-2">
            <strong class="mx-2 overflow-x-hidden" :class="{'move-cursor': draggableItems.length > 1 }"> <span>{{ item.label }}</span> </strong>

            <v-icon small @click="remove(index)">delete</v-icon>
          </v-chip>
        </div>
      </draggable>

      <v-btn icon @click="dialog = true; focus()">
        <v-icon>add_to_photos</v-icon>
      </v-btn>

      <div class="text-center">
        <v-dialog
          v-if="dialog"
          v-model="dialog"
          light
          persistent
          width="700"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Pick a facet value
            </v-card-title>

            <v-divider />

            <v-autocomplete
              v-model="pinFacetValue"
              :search-input="searchQuery"
              clearable
              :label="label"
              :items="facetsValues"
              :loading="loading"
              item-text="label"
              class="mx-5"
              color="blue"
              return-object
              item-color="info"
              menu-props="light"
              @focus="focus"
            />

            <v-card-actions>
              <v-spacer />
              <v-btn color="success" small @click="addItem()"> Add </v-btn>
              <v-btn color="info" small @click="dialog = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-select
        v-model="sortType"
        color="info"
        clearable
        menu-props="light"
        class="pt-4"
        label="Sort type"
        item-text="label"
        item-value="value"
        item-color="info"
        :items="sortOptions"

        @change="updateContent('sortType')"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useApolloClient } from '@vue/apollo-composable';

import draggable from 'vuedraggable';

import moment from 'moment';
import { useStore } from 'vue2-helpers/vuex';
import { getGraphqlSchema } from '@/graphql/index';

const { useFacetSettings } = require('@/utils/merch');

const { resolveClient } = useApolloClient();

const editableFacet = ref(null);
const draggableItems = ref([]);
const sortType = ref(null);
const store = useStore();

const sortOptions = [
  { label: 'Alphabetic order (ascending)', value: 'alpha' },
  // { label: 'Number of hits (descending)', value: 'count' },
  { label: 'Display only pinned items', value: 'hidden' }];

const { facetsList } = useFacetSettings(editableFacet.value, store.getters.rerenderingFacets);
const searchTypes = [
  { key: 'cycling', label: 'A vélo' },
  { key: 'walking', label: 'A pied' }
];
const searchType = ref(null);

const emit = defineEmits(['input']);

const props = defineProps({ value: { type: Object, default: () => {} }, label: { type: String, default: '' } });

const newValue = ref(props.value || {});

// ---- DIALOG -----
const facetsValues = ref([]);
const loading = ref(false);
let observable = null;
const dialog = ref(false);
const searchQuery = ref('');
const pinFacetValue = ref(null);

const searchAlgoliaFacetValues = (query = null) => {
  facetsValues.value = [];
  loading.value = true;

  const apollo = resolveClient();

  if (observable) {
    observable.unsubscribe();
  }

  const watchedQuery = apollo.watchQuery({
    query: getGraphqlSchema('searchAlgoliaFacetValues'),
    variables: {
      query: query || '',
      facet: editableFacet.value || '',
      referenceName: 'facetsRerenderingAlgolia'
    }
    // fetchPolicy: 'no-cache'
  });

  // Subscribe to it, and do something with the data
  observable = watchedQuery.subscribe(({ data }) => {
    loading.value = false;
    const configSelectedFacet = newValue.value && newValue.value[searchType.value] ? newValue.value[searchType.value].find(f => f.value === editableFacet.value) : null;
    facetsValues.value = data.searchAlgoliaFacetValues.facetsValues.map(i => {
      let disabled = false;
      if (configSelectedFacet && configSelectedFacet.pinItems && configSelectedFacet.pinItems.some(pin => pin.value === i.value)) disabled = true;

      return {
        value: i.value,
        label: i.label,
        disabled: disabled
      };
    });
  });
};

const focus = () => {
  searchQuery.value = '';
  searchAlgoliaFacetValues();
};

const updateSelectedFacet = () => {
  if (newValue.value && newValue.value[searchType.value]) {
    const facetConfig = newValue.value[searchType.value].find(facet => facet.value === editableFacet.value);

    draggableItems.value = facetConfig ? facetConfig.pinItems : [];
    sortType.value = facetConfig ? facetConfig.sortType : null;
  }
};

// ---- DIALOG -----

// REMOVE PIN ITEM
const remove = index => {
  draggableItems.value.splice(index, 1);
};

// UPDATE CONTETN
const updateContent = updateType => {
  const index = newValue.value[searchType.value].findIndex(facet => facet.value === editableFacet.value);
  if (updateType === 'sortType') {
    if (index < 0) {
      newValue.value[searchType.value].push({
        value: editableFacet.value,
        sortType: sortType.value,
        pinItems: null
      });
    } else {
      newValue.value[searchType.value][index].sortType = sortType.value;
    }
  }

  if (updateType === 'pinItem') {
    if (index < 0) {
      newValue.value[searchType.value].push({
        value: editableFacet.value,
        sortType: null,
        pinItems: draggableItems.value
      });
    } else {
      newValue.value[searchType.value][index].pinItems = draggableItems.value;
    }
  }
};

const addItem = () => {
  const item = { value: pinFacetValue.value.value, label: pinFacetValue.value.label, id: moment().unix() };
  draggableItems.value.push(item);
  pinFacetValue.value = null;
  dialog.value = false;
  updateContent('pinItem');
};

watch(
  newValue.value,
  val => {
    // Updates v-model on the parent
    emit('input', val || null);
  },
  { deep: true }
);

</script>

<style></style>
